"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDX_ROOT_DOCS_KEY = void 0;
exports.IDX_ROOT_DOCS_KEY = 'rootPosts';
